
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../services/timesheetreportsService';
import {timesheetService} from '../services/timesheetService';
import {formatterhelper} from '../helpers/dateformatter';
import {dataExporthelper} from '../helpers/exporthelper';
import {calculatepercent,calculatepercent2,calculatepercent3} from '../helpers/calculatepercent';
import { Paginator } from 'primereact/paginator';
import {loader} from '../compnents/loadermd';
import {Nodatacomp,Nodataprimecomp} from '../compnents/nodatacomp';
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { Dialog } from 'primereact/dialog';
import { timesheetuserService } from '../services/timesheetUserservice';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { FaBeer, FaCheck, FaEdit, FaLock, FaRecycle, FaSearch, FaUnlock,FaPlusCircle, FaTrash, FaCheckCircle } from "react-icons/fa";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
var XLSX = require("xlsx");
const Finalbillconfig = () => {
    
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        fromdate: '',
        todate: '',
        employee: '',
        client: 'ALL',
        subclient: 'ALL',
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [datacomptemp,setDatacomptemp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [cleintscompid,setClientscompid] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [empcomp,setempcomp] = useState([]); 
    const [userscomp,setuserscomp] = useState([]);
    const [userslists,setuserslists] = useState([]);
    const [usersliststemp,setusersliststemp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [isuserloaded,setuserloading] = useState(true);
    const [dialogtoggle,setdialogtoggle] = useState(false);
    
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [adjustments, setAdjustments] = useState([]);
    const [carryforward, setCarryforward] = useState([]);
    const [iscarryforward, setisCarryforward] = useState([]);
    const [autofilterobj, setautofilterobj] = useState({});
    
    const [errors, setErrors] = useState({});
    const auobj = {"id":"","client":"","subclient":"",
    "actualmin":0,"billingmin":0,"budgetmin":0,"finalbillmin":0,"type":"m"}; 
    const [autoobj,setAutoobj] = useState([auobj]);
     
    useEffect(()=>{
        // getemplist();
        _getclientslist();
        getfinalconfig();
        getmangrlist();
    },[]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
        
        if(name == 'client'){
            _getsubclient({clientid:value}); 
        }

        if(name == 'employee'){
            if(autoobj.length <= 0){
                setAutoobj([auobj]); 
            }
        }
   };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};
        
        if (formData.fromdate == '') {
            newErrors.fromdate = 'Field is required';
            valid = false;
          }

        if (formData.employee == '') {
          newErrors.employee = 'Field is required';
          valid = false;
        }

        if (formData.client == '') {
            newErrors.client = 'Field is required';
            valid = false;
          }

        setErrors(newErrors);

       return valid; 
    }  

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!validateForm()){
             return;
        }
        getfinalconfig();
        getsubclientadjustmanual();
    };

    function getreports({reportobj,pageno}){
        let emparr = [];
        setloading(false);
        timesheetreportService.showreportgettimesheet({formdataobj:reportobj,pageno:pageno})
        .then((response)=>{
            console.log('get reports');
            console.log(response);

            if(response.status == 200){
                response.data.data.data.forEach((value,index) =>{
                    emparr.push((<tr>
                        <th>{value.ID}</th>
                        <td>{value.Date}</td>
                        <td>{value.User}</td>
                        <td>{value.client}</td>
                        <td>{value.subclient}</td>
                        <td>budget</td>
                        <td>{value.Task}</td>
                        <td>{value.user_role}</td>
                        <td>{value.user_roletype}</td>
                        <td>{value.BilledMinutes}</td>
                        <td>{value.Minutes}</td>
                        <td>{value.Count}</td>
                        <td>{value.Remarks}</td>
                        <td>{value.approved_date}</td>
                        <td>{value.timesheetfilleddt}</td>
                    </tr>));
                }); 
            
                let totalpage = response.data.data.total; 
                setPages(totalpage);
                setDatacomp(emparr);
                
                setDatastate(true);
                setloading(true);
            }else{
                setDatacomp([]); 
                
                setDatastate(false);
                setloading(true);
                setPages(0);
            }
        }).catch((error)=>{
            console.log(error);
            setDatacomp([]);  
            setDatastate(false);
            setloading(true);
            setPages(0);
        });
    }  

    function getmangrlist(){
        let emparr = [];
        timesheetreportService.getmangrlist().then((response)=>{
            response.data.data.forEach((value,index) =>{
                emparr.push((<option value={value.id}>{value.name}</option>));
             });
             setempcomp(emparr);
         }).catch((error)=>{
 
         });   
    }

    function _getclientslist(){
        let managerid = 1;
        let emparr = [];
        let emparrtemp = [];
        timesheetreportService.getclientslist({managerid:managerid}).then((response)=>{
            console.log(response);
            response.data.data.forEach((value,index) =>{
                if(value.client != ''){
                    emparr.push((<option value={value.id}>{value.client}</option>));     
                } 
            });

            response.data.data.forEach((value,index) =>{
                if(value.client != '' && value.client != 'ALL'){
                    emparrtemp.push((<option value={value.client}>{value.client}</option>));
                } 
            });
            setClientscomp(emparr);
            setClientscompid(emparrtemp);
         }).catch((error)=>{
 
         });    
    }

    function _getsubclient({clientid}){
        let _clientid = clientid;
        let emparr = [];
        timesheetService.getallsubclient({client:_clientid}).then((response)=>{
            console.log(response);
            response.data.data.forEach((value,index) =>{
                emparr.push((<option value={value.subclient}>{value.subclient}</option>));
            });
            setsubClientscomp(emparr);
         }).catch((error)=>{
 
         });   
    }

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
        let pageno = 1;
        if(event.first == 0){
         pageno = 1;    
        }else{
         pageno = ((event.first/rows) + 1);  
        }
        // getUsers(pageno);
        getreports({reportobj:filterobj,pageno:pageno});
        // console.log(pageno);
    };

    const exportexcel = () =>{
        // getreports({reportobj:filterobj,pageno:pageno});
        try{
            exportToExcel();
        }catch(error){
           console.log(error); 
        } 
    }

    function exportToExcel() {
        dataExporthelper.exportFromhtml({id:'finalconfig-id',reportname:'Finalbillconfigreport'});
     }
    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Update Adjustment</span>
            <div className='pull-right'>
              <span>
               <Button type="button" onClick={()=> savefinalbilldata()} label="Save" className='custom-btn-style custom-button-height-style' severity="success" rounded /> 
              </span>
            </div>
        </div>
    );

    function getuserconfig({obj}){
       setdialogtoggle(true);
       getuserfinalbill({obj});
    }

    const handleAdjustmentChange = (index, newValue) => {
        const newAdjustments = [...adjustments];
        newAdjustments[index] = newValue;
        console.log(newAdjustments,'adjusmnet values');
        const updatedData = [...userslists]; // Create a shallow copy of the data array
        
        let newvaluedata = calculatepercent3(updatedData[index].percent,newValue);
        updatedData[index].percentval = newvaluedata;
        updatedData[index].adsadjustment = newValue;

        let decresedval = (newValue - updatedData[index].qafullhr); 
        updatedData[index].percentval = (updatedData[index].percent/100) * decresedval;
        
        setuserslists(updatedData);      
        setAdjustments(newAdjustments);
      };

      const handleCarryforward = (index,newValue) =>{
        const newAdjustments = [...carryforward];
        newAdjustments[index] = newValue;
        console.log(newAdjustments[index]);
        setCarryforward(newAdjustments);
      } 

      const isCarryforward = (index,newValue,value) =>{
        // console.log(newValue.target.checked);
        // const newAdjustments = [...userslists];
        // let tempval = 'no'; 
        // if(newValue.target.checked){
        //     tempval = 'yes';
        // }else{
        //     tempval = 'no';
        // }
        // newAdjustments[index].iscarryfoward = tempval;
        // // console.log(newAdjustments);
        // setusersliststemp(newAdjustments);
      }

    function getuserfinalbill({obj}){
        try{ 
            let temcomp= [];
            let formatteddate = formatterhelper.dateformatter({date:formData.fromdate});
            
            let filterdata = {
                subclient:obj.cl_id,
                fromdate:formatteddate,
                client_id:formData.client,
                managerid:formData.employee
            };
            setuserloading(false);
            // fromdate=2023-10&client_id=undefined&managerid=164&subclient=2213
             timesheetreportService.getuserfinalbill({obj:filterdata}).then((response)=>{
                if(response.status == 200){
                    setuserslists(response.data.data);
                    let tempadjustment = [];
                    response.data.data.forEach((value,index)=>{
                        // tempadjustment.push(value.adsadjustment);
                        tempadjustment.push(value.adsadjustment);
                        // newadjustment(index,'10','qafullhr');
                    });
                    setAdjustments(tempadjustment);
                    setuserloading(true);
                }else{
                    setuserslists([]);
                    setuserloading(true);
                }
               // setuserscomp(temcomp);  
             }).catch((error)=>{
                setuserloading(true);
             });
        }catch(error){
            console.log(error);
        }
    }

    function getfinalconfig(){
        try{
            let tempdata = [];
            setDatastate(false);
            setloading(false);

            let formatteddate = formatterhelper.dateformatter({date:formData.fromdate});
            let filterdata = {
                fromdate:formatteddate,
                client_id:formData.client,
                managerid:formData.employee
            }; 

            timesheetreportService.getfinalconfig({obj:filterdata}).then((response)=>{
                if(response.status == 200){
                    setDatacomp(response.data.data);
                    setDatacomptemp(response.data.data);
                    setDatastate(true);
                    setloading(true);                     
                }else{
                    setDatacomp([]);
                    setDatastate(false);
                    setloading(true);
                    setDatacomptemp([]);
                }

            }).catch((error)=>{
                setDatacomp([]);
               setDatastate(false);
               setloading(true);
               setDatacomptemp([]);
            });
        }catch(error){
           console.log(error); 
        }
    }
    
    function displaydata(){
        let emparr = [];
        if(datacomp == undefined){
             return;
        }
        datacomp.forEach((value,index)=>{
            //   console.log();

              let finalbill  = value.finalbill; 
              let percentval = (value.percentage/100) * finalbill; 
              // qasum 
            //   console.log(value.qasum,'qa sum'); 
            //   console.log(typeof value.qasum,'qa sum'); 
              if(value.qasum != '' && value.qasum != undefined && value.qasum != null){
                  percentval = value.qasum;
              }else{
                percentval = percentval;
              }
              if(percentval != null && percentval !== '') percentval = parseFloat(Number(percentval).toFixed(2));
              

              emparr.push((<tr id={`trid_${value.cl_id}`}>
                <td scope="col">{value.cl_id}</td>
                <td scope="col">{value.client}</td>
                <td scope="col">{value.subclient}</td>
                <td scope="col">{value.actual_hrs}</td>
                <td scope="col">{value.billmin}</td>
                <td scope="col">{value.budgetmin}</td>
                <td scope="col">{value.finalbill}</td>
                <td> {value.islocked == 'yes' ? (<FaLock className='edit-btn-style'/>) : value.islocked == 'no' ? (<FaUnlock  className='error'/>) : (<></>)}</td>
                
                {userdata.project == 'Year End' || userdata.roletype == 'admin' ? ( <td scope="col">{ percentval != null ?  percentval : ''} </td>) : (<></>)}
                {userdata.project == 'Year End' || userdata.roletype == 'admin' ? ( <td scope="col">{ value.qaaverage != null ?  value.qaaverage+'' : ''} </td>) : (<></>)}
                <td scope="col">{value.qafullhr}</td>
                <td scope="col">
                    <MdOutlineRemoveRedEye 
                    className='custom-cursor-style' 
                    onClick={()=>getuserconfig({obj:value})}/>
                    &nbsp;&nbsp;
                </td>
               </tr>));
           });

        return emparr;   
    }

    function newadjustment(index,value,qafullhr){
  
         if(qafullhr == 'isfullhr'){
            const updatedData = [...userslists]; // Create a shallow copy of the data array
            // Update the percent for the given index
            updatedData[index].isfullhr = !value;
            // console.log(value,'isfullhr value');
            setuserslists(updatedData);
        }
        else if(qafullhr == 'qafullhr'){
            console.log("qa full hr'");
            // console.log(value);
            const updatedData = [...userslists]; // Create a shallow copy of the data array
            // console.log(updatedData[index].adsadjustment);
            let decresedval = (updatedData[index].adsadjustment - value); 
            updatedData[index].percentval = (((updatedData[index].percent/100) * decresedval) + parseFloat(value)).toFixed(2);
            updatedData[index].qafullhr = value; // Update the percent for the given index
            setuserslists(updatedData);   
        }else{
            console.log(userslists); 
            const updatedData = [...userslists]; // Create a shallow copy of the data array
            updatedData[index].percentval = value; // Update the percent for the given index
            let percentno = calculatepercent2(userslists[index].adsadjustment,value);
            updatedData[index].percent = percentno; 
            setuserslists(updatedData);         
        }
    }

    function newadjustment2(index,value){
        console.log(userslists); 
        const updatedData = [...userslists]; // Create a shallow copy of the data array
        updatedData[index].percent = value;
        let percentno = calculatepercent3(value,userslists[index].adsadjustment);
        updatedData[index].percentval = percentno; 
        // adsadjustment
        // percentval
        // percent
        setuserslists(updatedData);
    }
    
    function getusercomp(){
        // console.log("adjustment");
        // console.log(adjustments);
        try{
            let temcomp= [];
            userslists.forEach((value,index)=>{
                // adjustments[index] = value.adsadjustment; 
                temcomp.push((
                   (<tr key={index}>
                    <td scope="col">{value.usr_id}</td>
                    <td scope="col">{value.subclientid}</td>
                    <td scope="col">{value.u_name}</td>
                    <td scope="col">{value.client}</td>
                    <td scope="col">{value.subclient}</td>
                    <td scope="col">{value.actualhrs}</td>
                    <td scope="col">{value.billed}</td>
                    <td scope="col">
                        <input
                        type="number"
                        className='form-control'
                        // value={adjustments[index]}
                        // value={value.adsadjustment}
                        value={adjustments[index]}
                        // onChange={(e) => newadjustment(index, e.target.value,'adjustment')}
                        onChange={(e) => handleAdjustmentChange(index, e.target.value)}
                        />
                    </td>
                    <td>
                       <input
                        type="number"
                        className='form-control'
                        value={value.qafullhr}
                        onChange={(e) => newadjustment(index, e.target.value,'qafullhr')}
                        />
                    </td>

                    <td scope="col">
                        <input
                        type="number"
                        className='form-control'
                        value={value.percentval}
                        // defaultValue={value.percentval}
                        onChange={(e) => newadjustment(index, e.target.value)}
                        />
                    </td>

                    <td scope="col">
                        <input
                        type="number"
                        className='form-control'
                        value={value.percent}
                        // defaultValue={value.percent}
                        onChange={(e) => newadjustment2(index, e.target.value)}
                        />
                    </td>

                    <td scope="col">
                        <input
                        type="number"
                        className='form-control'
                        defaultValue={value.carryforwardmin}
                        // value={carryforward[index]}
                        onChange={(e) => handleCarryforward(index, e.target.value)}
                        />
                    </td>

                    <td scope="col">
                        {value.iscarryfoward == 'yes' ? <FaCheck className='edit-btn-style'/> : <></>}
                        &nbsp;
                        &nbsp;
                        <input
                        type="checkbox"
                        // checked={value.iscarryfoward == 'yes' ? true : false}
                        value={value.iscarryfoward == 'yes' ? true : false}
                        onChange={(e) => isCarryforward(index, e,value)}
                        />
                        
                    </td>

                    {/* <td scope="col">
                        <input
                            type="checkbox"
                            checked={value.isfullhr == '1' ? true : false}
                            onChange={(e) => newadjustment(index, value.isfullhr,'isfullhr')}
                        />
                    </td> */}
                    
                    <td scope="col">Adjustment (Difference between Final billing to Billed Hrs as per timesheet)</td>
                    </tr>)     
                ));
            }); 
            return  temcomp;
        }catch(error){
            console.log(error);
           return []; 
        }
        
    }
    function savefinalbilldata(){
        if(userslists.length <=0){
             setdialogtoggle(false);
             return;
        }
        let date= formatterhelper.dateformatter({date:formData.fromdate});
         let tableexport_ = tableexport('user-table-export');
         let obj = {
            data_detail:tableexport_,
            date:date 
         };
         obj = JSON.stringify(obj);
         
         timesheetuserService.updatesubclientadjust({formdata:obj}).then((response)=>{
            console.log("udpate subcleint adjustment");
            console.log(response.data.flash);
            if(response.status == 200){
                toast.current.show({severity:'success', summary: "Final bill", detail:`Bill Updated`, life: 3000});    
                setdialogtoggle(false);
                getfinalconfig();
            }else{
                toast.current.show({severity:'error', summary: "Final bill", detail:response.data.flash, life: 3000});        
            }
         }).catch((error)=>{
            console.log(error);
         });
    }

    const tableexport = (id = 'user-table-export') => {
        const table = document.getElementById(id);
        const rows = table.getElementsByTagName("tr");
        const rowData = [];
        for (let i = 1; i < rows.length; i++) {
          const row = rows[i];
          const cells = row.getElementsByTagName("td");
          const rowDataItem = {};
          
          
          // Loop through each cell in the row
          for (let j = 0; j < cells.length; j++) {
            const cell = cells[j];
            const headerCell = table.rows[0].cells[j]; // Get the corresponding header cell
            const columnName = headerCell.innerText.toLowerCase().replace(/\s+/g, "");
            const input = cell.querySelector("input[type='number']");
            
            const inputtext = cell.querySelector("input[type='text']");
            const inputcheckbox = cell.querySelector("input[type='checkbox']");
            
            let cellValue = ''; 
            if (input) {
               cellValue = input.value.trim();
            }
            else if (inputcheckbox) {
                    cellValue = inputcheckbox.checked ? 1 : 0;
            }
            else{
               cellValue = cell.innerText.trim();
            }
            rowDataItem[columnName] = cellValue;
          }
      
          // Add the rowDataItem object to the rowData array
          rowData.push(rowDataItem);
        }
      
        return rowData;
    }

    const searchclients = (e) =>{
       console.log(e.target.value);
       let value = e.target.value; 
    //    datacomp
    //    datacomptemp 
       let _userdatalist = datacomptemp;
       const searchRegexClient    = new RegExp(value.toLowerCase());
       const searchRegexSubclient = new RegExp(value.toLowerCase());
       const foundItems = _userdatalist.filter(item => 
       //   (searchRegexClient.test(item.client) && searchRegexSubclient.test(item.subclient))
        (searchRegexClient.test(item.client.toLowerCase()) || searchRegexSubclient.test(item.subclient.toLowerCase()))
       );
     
       if (foundItems.length > 0) {
           console.log('items found.');
           setDatacomp(foundItems);
       } else {
           console.log('No items found.');
           setDatacomp([]);
       }
   }


   function addautoobj(){
      let tempobj = [...autoobj,auobj];
      console.log(tempobj);
      setAutoobj(tempobj);
   }

   function removeautoobj(key){
       let newobj = [...autoobj];
       console.log("id");  
        newobj.splice(key, 1);
        console.log(newobj,'new object');
        console.log(key);
        setAutoobj(newobj);    
   }

   const reject = () => {
    
   }

   function removeautoobjdb(value){
      confirmDialog({
        message: 'Are you sure you want to proceed?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        defaultFocus: 'accept',
        accept: () => {
            timesheetService.removeautoobjdb(value).then((response)=>{
                if(response.status == 200){
                   toast.current.show({severity:'success', summary: "Final bill", detail:`Deleted successfully`, life: 3000});    
                   getsubclientadjustmanual();
                }else{
                   toast.current.show({severity:'error', summary: "Final bill", detail:response.data.data, life: 3000});    
                }
            }).catch((error)=>{
               toast.current.show({severity:'error', summary: "Final bill", detail:`Error`, life: 3000});     
            }); 
        },
        reject
    }); 
  }

   function autochange(e,index){
        let newobj = [...autoobj];
        const { name, value } = e.target;
        if(name == 'client'){
            newobj[index].client = e.target.value;
        }
        if(name == 'subclient'){
            newobj[index].subclient = e.target.value;
        }
        if(name == 'actualmin'){
            newobj[index].actualmin = e.target.value;
        }

        if(name == 'billingmin'){
            newobj[index].billingmin = e.target.value;
        }

        if(name == 'budgetmin'){
            newobj[index].budgetmin = e.target.value;
        }

        if(name == 'finalbillmin'){
            newobj[index].finalbillmin = e.target.value;
        }
        setAutoobj(newobj); 
   }

   function saveautochange(value){
    if(value.client == ''){
        toast.current.show({severity:'error', summary: "Field required", detail:`Client is required`, life: 3000});   
        return;
    }  

    let date = formatterhelper.dateformatter({date:formData.fromdate});
    let obj = {'data_detail' : [value],'date':date}
    obj = JSON.stringify(obj);
    // return;
    // updatesubclientadjustmanual
    try{
        timesheetService.updatesubclientadjustmanual({formdata:obj}).then((response)=>{
            if(response.status == 200){
                toast.current.show({severity:'success', summary: "Final bill Config", detail:`Bill Updated`, life: 3000});    
                getsubclientadjustmanual();
            }else{
                toast.current.show({severity:'error', summary: "Final bill Config", detail:`Not Updated`, life: 3000});    
            }

        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Final bill Config", detail:`Error`, life: 3000});    
        });
    }catch(error){
       console.log(error); 
    }
   }

   function getsubclientadjustmanual(){
        // console.log(formData);
        // formData.fromdate = formatterhelper.dateformatter({date:formData.fromdate});
        let formatteddate = formatterhelper.dateformatter({date:formData.fromdate});
        let filterdata = {
            fromdate:formatteddate,
            client:formData.client,
            managerid:formData.employee
        };

        setautofilterobj(filterdata);

       timesheetService.getsubclientadjustmanual({formdata:filterdata}).then((response)=>{
          if(response.status == 200){
               setAutoobj(response.data.data);
               setDatastate(true);
            //    console.log(response.data.data);  
          }else{
            // console.log(auobj);
               setAutoobj([auobj]);
            //    console.log();
          }
       }).catch((error)=>{
           setAutoobj([auobj]);
       });
   }

    const autoobjData = () =>{
        let objarr = [];
        autoobj.forEach((value,index)=>{
            objarr.push(<tr className='border-color'>
           <td scope="col"></td>
           <td scope="col">
                <div className='container-box'>
                    <input type="text" style={{width:'178px'}} disabled value={autoobj[index].client} className='form-control text-center'/>
                    <select className='text-center' style={{width:'23px',border: '1px solid #ebebeb'}} name='client' value={autoobj[index].client} 
                    onChange={(e)=> autochange(e,index)}
                    >
                            <option value="">Select client</option>                  
                            {cleintscompid}
                    </select>
                </div> 
               {/* <select className='form-control text-center' name='client' value={autoobj[index].client} 
               onChange={(e)=> autochange(e,index)}
              >
                    <option value="">Select client</option>                  
                    {cleintscompid}
               </select> */}
           </td>
           <td scope="col"><input type="text" name="subclient" onChange={(e)=> autochange(e,index)} value={value.subclient} className='form-control text-center'/></td>
           <td scope="col"><input type="number" name="actualmin" onChange={(e)=> autochange(e,index)} Value={value.actualmin} placeholder='Actualmin' className='form-control text-center' defaultvalue="actual_hrs"/></td>
           <td scope="col"><input type="number" name="billingmin" onChange={(e)=> autochange(e,index)} Value={value.billingmin} placeholder='Billingmin' className='form-control text-center' defaultvalue="billmin"/></td>
           <td scope="col"><input type="number" name="budgetmin" onChange={(e)=> autochange(e,index)} Value={value.budgetmin} placeholder='Budgetmin' className='form-control text-center' defaultvalue="budgetmin"/></td>
           <td scope="col"><input type="number" name="finalbillmin" onChange={(e)=> autochange(e,index)} Value={value.finalbillmin} placeholder='Finalbill' className='form-control text-center' defaultvalue="finalbill"/></td>
           {/* <td> </td> */}
           {userdata.project == 'Year End' || userdata.roletype == 'admin' ? ( <td scope="col"></td>) : (<></>)}
           <td></td>
           <td></td>
           <td></td>
           <td scope="col" colSpan="2">
               {/* <MdOutlineRemoveRedEye 
               className='custom-cursor-style' 
               onClick={()=>getuserconfig({obj:value})}/> */}
              <FaCheckCircle className='edit-btn-style' style={{fontSize:'21px'}} onClick={() => saveautochange(value)}/>
               &nbsp;
               <button className='btn btn-info' onClick={() => addautoobj()}><FaPlusCircle style={{color:'white'}}/></button>
               &nbsp;
               <button className='btn btn-danger' onClick={() => value.id.length <=0 ? removeautoobj(index) : removeautoobjdb(value) }><FaTrash/></button>
           </td>
       </tr>);
       });
       return objarr;
    }

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <div className="invisible-divider-sm"></div>
            <h6>Final bill config</h6>
            <Dialog header={headerElement} position={"top"} visible={dialogtoggle} style={{ width: '93vw',left:'3.2%' }} onHide={() => setdialogtoggle(false)}>
               {/* <form onSubmit={handleSubmit}> */}
               <div className='col-md-12'>
                 <div className='row'>
                    <div className='col-md-12'>
                        {!isuserloaded ? (loader.Loadermd()) : userslists != undefined && userslists.length <= 0 ? (<Nodatacomp/>) : ( 
                            <table class="table table-bordered" id="user-table-export">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Sub Id</th>
                                <th scope="col">Username</th>
                                <th scope="col">Client</th>
                                <th scope="col">Sub Client</th>
                                <th scope="col">Actualhrs in (Min)</th>
                                <th scope="col">Billmin in (Min)</th>
                                <th scope="col">Final billing in (Min)</th>
                                <th scope="col">QA 100 Adjust (Min)</th>
                                <th scope="col">QA Min</th>
                                <th scope="col">QA percent</th>
                                <th scope="col">Carry forward</th>
                                <th scope="col">DoCarry</th>
                                {/* <th scope="col">100 %</th> */}
                                <th scope="col">Adjustment (Difference between Final billing to Billed Hrs as per timesheet)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getusercomp()}
                        </tbody>
                    </table>)}
                    
                     </div>
                  </div> 
                  <br/>  
                 
               </div>
              {/* </form> */}
             </Dialog>
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-2">
                        <label className='pull-left'>Select Month</label>
                        <Calendar view="month" value={formData.fromdate} name="fromdate" onChange={handleChange} className='calender-custom-style' />
                        {errors.fromdate && <span className='error'>{errors.fromdate}</span>}
                    </div>
                    
                    <div className="col-md-2">
                        <label className='pull-left'>Select Manager</label>
                        <select className='form-control' name="employee" value={formData.employee} onChange={handleChange}>
                            <option value="">Select Manager</option>
                            {empcomp}
                        </select>
                        {errors.employee && <span className='error'>{errors.employee}</span>}
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>Select Client</label>
                        <select className='form-control' name='client' value={formData.client} onChange={handleChange}>
                            <option value=''>Select client</option>
                            <option value='ALL'>ALL</option>
                            {cleintscomp}
                        </select>
                        {errors.client && <span className='error'>{errors.client}</span>}
                    </div>
                   
                    <div className="col-md-2">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Show" severity="success" rounded className='custom-btn-style' />
                            &nbsp;&nbsp;&nbsp; 
                            <Button type='button' stype="button" label="Export" severity="info" rounded className='custom-btn-style' onClick={()=>exportexcel()} />
                        </div>
                        
                    </div>
                 </div>
              </form>
                  
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'>
                       <span className="p-input-icon-left pull-left">
                        {/* onKeyDown={(e)=>{searchusers(e)}} */}
                        <FaSearch />
                        <InputText placeholder="Search" className="search-box-height"
                        onKeyDown={(e)=>{searchclients(e)}}/>
                        </span>
                   
                    </div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                        {isloaded && dataavail ? (<Paginator first={first} rows={rows} totalRecords={totalpages} rowsPerPageOptions={[15]} onPageChange={onPageChange} />) : (<></>)}
                        
                    </div>
                </div>
               
                <div className='row'>
                    <div className='col-md-12'>
                    {
                    !isloaded ? loader.Loadermd() : dataavail ?
                    (
                    <table class="table table-bordered" id="finalconfig-id">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Client</th>
                                <th scope="col">Sub Client</th>
                                <th scope="col">Actual hours in (Min)</th>
                                <th scope="col">Bill in (Min)</th>
                                <th scope="col">Budget in (Min)</th>

                                <th scope="col">Final Billing in (Min)</th>
                                <th scope="col">Islocked</th>
                                {userdata.project == 'Year End' || userdata.roletype == 'admin'  ? ( <th scope="col">QA Min</th>) : (<></>)}
                                {userdata.project == 'Year End' || userdata.roletype == 'admin'  ? ( <th scope="col">QA Avg</th>) : (<></>)}
                                <th scope="col">QaFullhr</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displaydata()}
                            {autoobjData()}
                        </tbody>
                    </table>) 
                    : (<Nodataprimecomp />)
                    } 
                    </div>
                </div>
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Finalbillconfig;